import { RankingTable } from "./ranking_table";
import $ from "jquery";

type ExtendedEntry = [number, string, number, number]; // [rank, name, stats, itemId]

class ReverseMatchesRankingTable extends RankingTable {
  private readonly DEFAULT_TYPE_REVERSE = "si";

  private defaultType(): string {
    return this.DEFAULT_TYPE_REVERSE;
  }

  private keyword(): string {
    return $("#keyword").val() as string;
  }

  setQueryParams(params: any): void {
    delete params.format;
    delete params.types;
    delete params.dimension;
    delete params.area;
    delete params.category;
    params.type = this.type;
    this.queryParams = params;
  }

  protected tableBody(): string {
    const extendedEntries = this.entries as unknown as ExtendedEntry[];
    const rows = extendedEntries.map((entry, index) => {
      const klass = index % 2 === 0 ? "odd" : "even";
      const [rank, name, stats, itemId] = entry;
      const formattedStats = this.requireFormatStats()
        ? this.formatStats(stats)
        : `${stats}${this.valueUnit}`;
      return `
        <tr class="${klass}">
          <td class="rank">${this.rankingNumber(rank)}</td>
          <td>${this.hyperLinkFor(name, itemId)}</td>
          <td>${formattedStats}</td>
        </tr>
      `;
    });
    return `<tbody>${rows.join("")}</tbody>`;
  }

  protected hyperLinkFor(itemName: string, itemId?: number): string {
    if (itemId !== undefined) {
      const extendedParams = Object.assign({}, this.queryParams, {
        "selection[]": itemId,
      });
      const urlParams = $.param(extendedParams);
      return `<a href="${this.destinationPath()}/${this.keyword()}?${urlParams}">${itemName}</a>`;
    } else {
      // Fallback to parent implementation
      const urlParams = $.param(this.queryParams);
      return `<a href="${this.destinationPath()}/${itemName}?${urlParams}">${itemName}</a>`;
    }
  }
}

export { ReverseMatchesRankingTable };
